import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import FivaLayout from "../../Layout/FivaLayout";
import HeadComponent from "../../components/HeadComponent/HeadComponent";
import { transformCloudinaryURL } from "../../utils/imageUtils";
import CustomSkeleton from "../../components/CustomSkeleton/CustomSkeleton";
import dynamic from "next/dynamic";
var DynamicComponent = dynamic(function() {
    return import("../../components/_Blog/ArticleCard/ArticleCard");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("../../components/_Blog/ArticleCard/ArticleCard")
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ _jsx(CustomSkeleton, {});
    }
});
var Article = function(param) {
    var articleData = param.articleData, latestArticles = param.latestArticles;
    var headerProps = {
        title: articleData === null || articleData === void 0 ? void 0 : articleData.headers.title,
        keywords: articleData === null || articleData === void 0 ? void 0 : articleData.headers.keywords,
        content: articleData === null || articleData === void 0 ? void 0 : articleData.headers.content,
        imageUrl: (articleData === null || articleData === void 0 ? void 0 : articleData.small_image) ? transformCloudinaryURL(articleData === null || articleData === void 0 ? void 0 : articleData.small_image, 720, 1040) : ""
    };
    return /*#__PURE__*/ _jsxs(FivaLayout, {
        blue: false,
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(DynamicComponent, _object_spread_props(_object_spread({}, articleData), {
                userData: articleData === null || articleData === void 0 ? void 0 : articleData.author,
                latestArticles: latestArticles
            }))
        ]
    });
};
export var __N_SSG = true;
export default _withSuperJSONPage(Article);
